import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ExamProvider } from './contexts/ExamContext';
import Welcome from './components/Welcome';
import Question from './components/Question';
import Results from './components/Results';
import Review from './components/Review';
import Header from './components/Header';
import AccessGate from './components/AccessGate';
import './styles/App.css';

function App() {
  const [accessGranted, setAccessGranted] = useState(false);

  const handleAccessGranted = () => {
    setAccessGranted(true);
  };

  if (!accessGranted) {
    return <AccessGate onAccessGranted={handleAccessGranted} />;
  }

  return (
    <ExamProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/exam" element={<Question />} />
          <Route path="/results" element={<Results />} />
          <Route path="/review" element={<Review />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </ExamProvider>
  );
}

export default App;